<template>
  <div>


    <div class="row">
      <div class="col-xs-12 col-sm-6 col-sm-offset-3">

<!--        <h2>Review and Deploy</h2>-->
<!--        <em>Tell us about yourself</em><br/>-->
        <!--          <em>We'll redirect you to AWS where you can review and deploy Skippr</em>-->

        <em><i class="fa fa-check p1 m-t"></i> Discover your schemas, no breaking changes</em><br />
        <em><i class="fa fa-check p1 m-t"></i> Ingest and optimise your data</em><br />
        <em><i class="fa fa-check p1 m-t mb-20"></i> Slash costs and time to value</em>


        <div class="m-t" role="form" _lpchecked="1">
          <input id="deploy-skippr" type="hidden" name="_token" value="TVkumuyrNWs5Z2OdjyHv2FKxaKnnbMPJxAasm9Db">

          <div class="form-group">
            <input id="first_name" type="text" class="form-control" name="first_name" placeholder="First Name"
                   v-on:input="customer.firstname = $event.target.value" required="" autofocus="">
          </div>

          <div class="form-group">
            <input id="last_name" type="text" class="form-control" name="last_name" placeholder="Last Name"
                   v-on:input="customer.lastname = $event.target.value" required="" autofocus="">
          </div>

          <!--            <div class="form-group">-->
          <!--              <input id="company_name" type="text" class="form-control" name="company_name" placeholder="Company Name" v-on:input="customer.company = $event.target.value" required="" autofocus="">-->

          <!--            </div>-->

          <div class="form-group">

            <input id="email" type="email" class="form-control" name="email" placeholder="Business Email"
                   v-on:input="customer.email = $event.target.value" required="required">
<!--            <em>We'll send your API Key to this email address.</em>-->

          </div>

          <!--            <div class="form-group">-->

          <!--              <input id="phone" type="phone" class="form-control" name="password" placeholder="Phone" required="" v-on:input="customer.phone = $event.target.value">-->

          <!--            </div>-->


          <div class="form-group">
            <div class="checkbox">
              <label>
                <div class="icheckbox_square-green">
                  <input type="checkbox" required="required" v-on:change="customer.terms = $event.target.checked">
                  <ins class="iCheck-helper"></ins>
                </div>
                <i></i> I agree to the <a href="/terms" target="_blank">terms and privacy policy</a>
              </label>

            </div>
          </div>

          <!--            <a href="https://console.skippr.io/register" class="btn btn-secondary" type="submit">Try The Beta</a>-->

        </div>


        <button v-on:click="awsCreateStack()" class="btn btn-primary block pull-right full-width m-b">Try Now <i
          class="fa fa-arrow-circle-right"></i></button>

      </div>
    </div>

  </div>
</template>

<script>

import _ from "lodash";

export default {
  name: 'TryNowDeployWizard',
  components: {},
  props: {
    msg: String,
    awsRegion: String,
  },
  data() {
    return {
      customer: {
        firstname: '',
        lastname: '',
        company: '',
        email: '',
        phone: '',
        terms: ''
      }
    }
  },
  created() {
    this.$gtag.event('deploy_wizard', {
      event_category: 'deploy-wizard',
      event_label: 'deploy-wizard-signup-form-view'
    });
  },
  methods: {
    clickEvent(name) {
      this.$gtag.event('click', {
        event_category: 'deploy-wizard',
        event_label: name,
      })
    },
    awsCreateStack: _.debounce(function () {
      this.$gtag.event('deploy_wizard', {
        event_category: 'deploy-wizard',
        event_label: 'deploy-wizard-signup-form-attempt-submit'
      });


     if (!this.customer.terms) {
        alert('Please agree to the terms and privacy policy')
        return
      }


      // validate email is valid
      if (!this.customer.email.includes('@') && !this.customer.email.includes('.')) {
        alert('Please enter a valid business email address')
        return
      }

      // ensure email address is a business email address
      const emailDomain = this.customer.email.split('@')[1]
      const nonBusinessEmailDomains = ['test', 'example', 'gmail', 'hotmail', 'yahoo', 'outlook', 'icloud', 'aol', 'msn', 'live', 'me', 'mac', 'excite', 'inbox', 'gmx', 'fastmail', 'yandex', 'zoho', 'gmx', 'mail', 'email', 'yopmail', 'protonm'];

     for (let i = 0; i < nonBusinessEmailDomains.length; i++) {
       if (emailDomain.includes(nonBusinessEmailDomains[i])) {
         alert('Please enter a valid business email address')
         return
       }
     }


      // if (this.awsRegion) {

      try {

        window.axioslicense.put('/', this.customer)
          .then((res) => {


            if (res.data.api_key) {

              let api_key = res.data.api_key

              window.lintrk('track', { conversion_id: 2104889 });

              // track conversion
              this.$gtag.event('deploy_wizard_submit', {
                event_category: 'deploy-wizard',
                event_label: 'deploy-wizard-signup-form-submit',
                transaction_id: api_key,
                value: 1,
                currency: 'USD',
                // callback: () => {
                //   console.log('conversion tracked, redirecting');
                // }
              });

              window.twq('event', 'tw-ofqmg-ofslu', {
                conversion_id: api_key,
              });

              window.adroll.track("deploy_wizard_submit");

              window.location = 'https://docs.skippr.io/getting-started?api_key=' + api_key
            }
            // setTimeout(() => {
            //   window.location = 'https://docs.skippr.io/getting-started/docker?api_key=' + api_key
            // }, 10000)


          }).catch((err) => {
          console.log(err);
          // window.location = 'https://docs.skippr.io/getting-started/docker'

        });

      } catch (err) {
        console.log(err);
      }
    }, 500),

  },
  head: {

    title: {
      inner: 'Try Now',
      separator: '-',
      complement: 'Data Integration and Preparation'
    },
    //omited
  }
}
</script>

<style>
#hubspot-messages-iframe-container.widget-align-right {
  display: none !important;
}
</style>
